export const DEFAULT_ERROR_MESSAGE =
  'There was some problem in carrying out this action. Please try again later!';
